import OtpInput from 'react-otp-input';
import React, { Component } from 'react';
import { Button, Card, Col, Form, Icon, Row } from 'antd';
import { connect } from 'react-redux';
import { CardActionsProps } from './YscCardActionsDataHandler';
import { StyledOtpGeneration } from '../PayBalance/StyledPayBalance';
import { BLOCK_CARD_VALIDATION_MESSAGE, LOCK_CARD_VALIDATION_MESSAGE, UNLOCK_CARD_VALIDATION_MESSAGE, YSCCARD_CONSTANTS } from './constants';
import { NETWORKCARD_CONSTANTS } from '../NetworkCards/constants';

class CardActionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  validationMessage() {
    const {
      type = '',
    } = this.props;
    switch (type) {
      case 'LOCK_CARD':
        return LOCK_CARD_VALIDATION_MESSAGE;
      case 'UNLOCK_CARD':
        return UNLOCK_CARD_VALIDATION_MESSAGE;
      case 'BLOCK_CARD':
        return BLOCK_CARD_VALIDATION_MESSAGE;
      default:
        return '';
    }
  }

  verifyOtp() {
    const {
      type = '',
      verifyLockCardOTP,
      verifyUnlockCardOTP,
      verifyBlockCardOTP,
    } = this.props;
    switch (type) {
      case 'LOCK_CARD':
        return verifyLockCardOTP;
      case 'UNLOCK_CARD':
        return verifyUnlockCardOTP;
      case 'BLOCK_CARD':
        return verifyBlockCardOTP;
      default:
        return '';
    }
  }

  isLoadingStatus() {
    const {
      type = '',
      isLoadStatus = false,
      isLoadingStatus = false,
    } = this.props;
    switch (type) {
      case 'LOCK_CARD':
        return isLoadStatus;
      case 'UNLOCK_CARD':
        return isLoadStatus;
      case 'BLOCK_CARD':
        return isLoadingStatus;
      default:
        return false;
    }
  }

  cardActionsScreen() {
    const {
      MobileNumber = '',
      OTP = '',
      handleOtpChange,
      showResendText = false,
      handleResendOTP,
      remainingTime = 0,
    } = this.props;
    const formattedPhone = `XXXXXX${MobileNumber.slice(-4)}`;
    return (
      <StyledOtpGeneration>
        <Card className="rounded otp-card margin-b-1">
          <Row align="top" type="flex" justify="start" gutter={10}>
            <Col xs={24} sm={24} md={2} lg={2} xl={2}>
              <Icon
                type="check-circle"
                theme="filled"
                className="check-icon"
              />
            </Col>
            <Col xs={24} sm={24} md={22} lg={22} xl={22}>
              <p className="font-14">OTP has been Successfully sent to <strong>{formattedPhone}</strong>. <br />
                {this.validationMessage()}
              </p>
              <p className="font-12 text-red ">
                {NETWORKCARD_CONSTANTS.CONTACT_CUSTOMER_CARE}
              </p>
            </Col>
          </Row>
        </Card>
        <Row align="middle" type="flex" justify="center" gutter={10}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-1 margin-b-1">
            <OtpInput
              containerStyle={{ justifyContent: 'center' }}
              className="custom-otp-inputs"
              value={OTP}
              onChange={handleOtpChange}
              numInputs={6}
              separator={<span className="padding-1"></span>}
              isInputNum
            />
          </Col>
          <div>
            {showResendText ? (
              <span
                role="presentation"
                className="text-red"
                style={{ cursor: 'pointer' }}
                onClick={handleResendOTP}
              >
                Resend OTP
              </span>
            ) : (
              <span> Resend OTP in 0 : {remainingTime} sec</span>
            )}
          </div>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
            <Button
              type="primary"
              className="green-btn width-5 margin-t-1"
              onClick={this.verifyOtp()}
              loading={this.isLoadingStatus()}
            >
              Confirm
            </Button>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <p className="font-14 nomargin-bottom margin-t-2">
              {YSCCARD_CONSTANTS.CUSTOMER_SERVICE}<br />
              <strong>{YSCCARD_CONSTANTS.CUSTOMER_SERVICE_NUMBER}</strong><br />
              {YSCCARD_CONSTANTS.CUSTOMER_SERVICE_TIMINGS}
            </p>
          </Col>
        </Row>
      </StyledOtpGeneration>
    );
  }

  render() {
    return (
      this.cardActionsScreen()
    );
  }
}

CardActionsPage.propTypes = CardActionsProps;

const CardActionsPageWrapper = Form.create({ name: 'normal_admin' })(CardActionsPage);
const component = connect(null, null)(CardActionsPageWrapper);
export { CardActionsPage, CardActionsPageWrapper };
export default component;



// WEBPACK FOOTER //
// client/containers/YscCardActions/CardActionsPage.js